"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthContext = void 0;
const react_1 = __importStar(require("react"));
const sync_1 = require("@food/sync");
const loggedContext_1 = require("../utils/loggedContext");
const auth_1 = require("../logic/auth");
const { Provider } = loggedContext_1.loggedContext;
const localListener = new sync_1.Channel('@food/auth');
const AuthContext = ({ children }) => {
    const [userKey, setUserKey] = (0, react_1.useState)((0, auth_1.getValidToken)());
    (0, react_1.useEffect)(() => {
        localListener.onmessage = (ev) => {
            const { data } = ev;
            if (data.type === 'USER_CHANGED' && data.args && data.args.newUser) {
                if (data.args.newUser) {
                    setUserKey((0, auth_1.getValidToken)());
                }
                else {
                    setUserKey(null);
                }
            }
        };
    });
    return react_1.default.createElement(Provider, { value: userKey }, children);
};
exports.AuthContext = AuthContext;
//# sourceMappingURL=AuthContext.js.map